import { useTheme } from '@/contexts/ThemeContext';

const screens = [
  {
    title: 'Dashboard Financeiro',
    subtitle: 'ERP Corporativo',
    image: 'https://readdy.ai/api/search-image?query=professional%20financial%20dashboard%20ERP%20software%20interface%20dark%20navy%20blue%20theme%2C%20revenue%20charts%2C%20expense%20tracking%2C%20cash%20flow%20graphs%2C%20KPI%20cards%20with%20numbers%2C%20data%20tables%2C%20modern%20corporate%20UI%20design%2C%20cyan%20accent%20colors&width=560&height=360&seq=proof-fin-01&orientation=landscape',
    tag: 'Financeiro',
    tagColor: 'text-cyan-600',
    tagBgDark: 'border-cyan-500/30 bg-cyan-500/10',
    tagBgLight: 'border-cyan-300/50 bg-cyan-50',
  },
  {
    title: 'Gestão Escolar',
    subtitle: 'ERP para Escolas',
    image: 'https://readdy.ai/api/search-image?query=school%20management%20ERP%20software%20dashboard%20dark%20theme%2C%20student%20list%2C%20academic%20performance%20charts%2C%20attendance%20tracking%2C%20grade%20reports%2C%20class%20schedule%2C%20modern%20educational%20software%20interface%20professional%20UI&width=560&height=360&seq=proof-esc-01&orientation=landscape',
    tag: 'Educação',
    tagColor: 'text-emerald-600',
    tagBgDark: 'border-emerald-500/30 bg-emerald-500/10',
    tagBgLight: 'border-emerald-300/50 bg-emerald-50',
  },
  {
    title: 'Controle de Materiais',
    subtitle: 'ERP para Reciclagem',
    image: 'https://readdy.ai/api/search-image?query=recycling%20material%20control%20ERP%20dashboard%20dark%20navy%20theme%2C%20material%20inventory%20table%2C%20weight%20tracking%20charts%2C%20supplier%20management%2C%20production%20reports%2C%20environmental%20metrics%2C%20professional%20industrial%20software%20interface&width=560&height=360&seq=proof-rec-01&orientation=landscape',
    tag: 'Reciclagem',
    tagColor: 'text-lime-700',
    tagBgDark: 'border-lime-500/30 bg-lime-500/10',
    tagBgLight: 'border-lime-300/50 bg-lime-50',
  },
  {
    title: 'Relatórios & Indicadores',
    subtitle: 'Business Intelligence',
    image: 'https://readdy.ai/api/search-image?query=business%20intelligence%20BI%20dashboard%20dark%20theme%2C%20advanced%20analytics%2C%20multiple%20charts%20and%20graphs%2C%20KPI%20metrics%2C%20data%20visualization%2C%20performance%20indicators%2C%20executive%20report%20interface%2C%20professional%20corporate%20software%20dark%20navy%20blue&width=560&height=360&seq=proof-bi-01&orientation=landscape',
    tag: 'Analytics',
    tagColor: 'text-orange-600',
    tagBgDark: 'border-orange-500/30 bg-orange-500/10',
    tagBgLight: 'border-orange-300/50 bg-orange-50',
  },
];

export default function ProductProof() {
  const { isDark } = useTheme();

  return (
    <section
      id="sistemas"
      className={`py-28 relative overflow-hidden transition-colors duration-500 ${isDark ? 'bg-[#060b18]' : 'bg-slate-50'}`}
    >
      <div className={`absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent to-transparent ${
        isDark ? 'via-white/10' : 'via-slate-300/60'
      }`}></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-16 gap-4">
          <div className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full border ${
            isDark ? 'border-cyan-500/30 bg-cyan-500/10' : 'border-cyan-400/40 bg-cyan-50'
          }`}>
            <i className="ri-computer-line text-cyan-500 text-sm"></i>
            <span className="text-cyan-600 text-xs font-semibold tracking-widest uppercase">Prova Visual</span>
          </div>
          <h2 className={`text-3xl lg:text-5xl font-bold leading-tight ${isDark ? 'text-white' : 'text-slate-900'}`}>
            Sistemas reais,{' '}
            <span className="bg-gradient-to-r from-cyan-500 to-cyan-400 bg-clip-text text-transparent">
              resultados concretos
            </span>
          </h2>
          <p className={`text-lg max-w-2xl ${isDark ? 'text-slate-400' : 'text-slate-600'}`}>
            Veja como nossos sistemas se parecem na prática. Interfaces profissionais, dados organizados e fluxos pensados para o usuário final.
          </p>
        </div>

        {/* Main large screen */}
        <div className={`rounded-2xl overflow-hidden border mb-6 ${
          isDark ? 'border-white/10 shadow-2xl shadow-black/50' : 'border-slate-200 shadow-lg shadow-slate-200/60'
        }`}>
          <div className={`flex items-center gap-2 px-5 py-3 border-b ${
            isDark ? 'border-white/10 bg-[#0d1526]' : 'border-slate-100 bg-white'
          }`}>
            <div className="w-3 h-3 rounded-full bg-red-500/60"></div>
            <div className="w-3 h-3 rounded-full bg-yellow-500/60"></div>
            <div className="w-3 h-3 rounded-full bg-green-500/60"></div>
            <span className={`ml-4 text-xs ${isDark ? 'text-slate-500' : 'text-slate-400'}`}>Granato ERP — Painel Gerencial Completo</span>
            <div className="ml-auto flex items-center gap-2">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
              <span className="text-green-500 text-xs">Online</span>
            </div>
          </div>
          <img
            src="https://readdy.ai/api/search-image?query=complete%20ERP%20management%20system%20full%20dashboard%20dark%20navy%20blue%20theme%2C%20sidebar%20navigation%20with%20modules%2C%20main%20content%20area%20with%20charts%20and%20tables%2C%20KPI%20cards%2C%20financial%20data%2C%20inventory%20status%2C%20recent%20transactions%2C%20professional%20enterprise%20software%20interface%20high%20quality&width=1200&height=600&seq=proof-main-01&orientation=landscape"
            alt="Painel Gerencial ERP Granato"
            className="w-full object-cover object-top"
          />
        </div>

        {/* 4 smaller screens */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {screens.map((screen) => (
            <div
              key={screen.title}
              className={`group rounded-xl overflow-hidden border transition-all duration-300 cursor-pointer ${
                isDark
                  ? 'border-white/8 bg-[#0d1526] hover:border-cyan-500/25'
                  : 'border-slate-200 bg-white hover:border-cyan-400/40'
              }`}
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={screen.image}
                  alt={screen.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${
                  isDark ? 'from-[#0d1526] via-transparent to-transparent' : 'from-white/60 via-transparent to-transparent'
                }`}></div>
              </div>
              <div className="p-4">
                <span className={`text-xs px-2.5 py-1 rounded-full border font-medium ${screen.tagColor} ${
                  isDark ? screen.tagBgDark : screen.tagBgLight
                }`}>
                  {screen.tag}
                </span>
                <h4 className={`text-sm font-bold mt-2 ${isDark ? 'text-white' : 'text-slate-900'}`}>{screen.title}</h4>
                <p className={`text-xs mt-1 ${isDark ? 'text-slate-500' : 'text-slate-500'}`}>{screen.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
